import { useQuery } from 'react-query';
import { getTags } from '../services/tags-api.service';

export default function useTags() {
  return useQuery(['tags'], () => getTags().then(({ data }) => data), {
    refetchOnWindowFocus: false
  });
}
